import React from 'react';
import { Link } from 'react-router';
import AppRoutes from '../../routes/routes';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';

export default function MarketingPublications({ newsItems, recentlyPublished, popularCategories }) {
    const articles = (newsItems || []).slice(0, 4);

    return (
        <section style={{ background: '#f8fafc' }}>
            <div className="section" id="publications">
                <div className="container">

                    <div className="publications-grid-resp">
                        {/* Left Column: News Items mapped as Feature Cards */}
                        <div>
                            <div className="eyebrow reveal" style={{ justifyContent: 'flex-start' }}>
                                <div className="eyebrow-line"></div>
                                <span className="eyebrow-text">Open Research</span>
                                <div className="eyebrow-line"></div>
                            </div>
                            <h2 className="section-title reveal reveal-delay-1 text-left">Latest from the<br /><em>Neurochecklists</em> network</h2>
                            <p className="section-sub reveal reveal-delay-2 text-left ml-0">Explore our most recently published clinical checklists, deep-dive articles, and most popular research categories.</p>

                            <h3 className="cap-title mb-20-px">Recent Articles</h3>
                            <div className="feature-grid feature-grid-auto">
                                {articles.map((item, index) => (
                                    <a
                                        href={item.link}
                                        key={item.link || index}
                                        className="feature-card article-card"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => PostHogService.capture(PostHogEvents.NEWS_ITEM_CLICKED, { title: item.title, url: item.link, source: 'substack' })}
                                    >
                                        {item.image ? (
                                            <div className="article-card-image-wrap">
                                                <img className="article-card-image" src={item.image} alt="" loading="lazy" />
                                            </div>
                                        ) : ''}
                                        <div className="feature-title text-md">{item.title}</div>
                                        {item.excerpt ? <div className="feature-desc mt-8">{item.excerpt}</div> : ''}
                                        <div className="article-read-more">Read article</div>
                                    </a>
                                ))}
                                {!articles.length ? (
                                    <a
                                        href={AppRoutes.substack}
                                        className="feature-card article-card"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={() => PostHogService.capture(PostHogEvents.NEWS_ITEM_CLICKED, { title: 'Substack', url: AppRoutes.substack, source: 'substack' })}
                                    >
                                        <div className="feature-title text-md">Read the latest on Substack</div>
                                        <div className="feature-desc mt-8">Recent posts are temporarily unavailable here.</div>
                                        <div className="article-read-more">Open Substack</div>
                                    </a>
                                ) : ''}
                            </div>
                            <a
                                href={AppRoutes.substack}
                                className="btn btn-primary-sm publications-see-more"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => PostHogService.capture(PostHogEvents.NEWS_ITEM_CLICKED, { title: 'See more on Substack', url: AppRoutes.substack, source: 'substack' })}
                            >
                                See more on Substack &rarr;
                            </a>
                        </div>

                        {/* Right Column: Checklists & Categories */}
                        <div>
                            <div className="publications-sidebar-card">
                                <h3 className="cap-title cap-sidebar-title">Recently Published Checklists</h3>
                                <ul className="cap-points cap-link-list">
                                    {(recentlyPublished || []).slice(0, 6).map((item, index) => (
                                        <li key={item.id || index}>
                                            <span className="cap-check cap-icon-sm">📋</span>
                                            <Link to={`${AppRoutes.checklists}${item._slugs}`} onClick={() => PostHogService.capture(PostHogEvents.RECENTLY_PUBLISHED_CLICKED, { title: item.title, id: item.id })} className="hover-blue">
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>

                                <h3 className="cap-title cap-sidebar-title mt-32">Popular Categories</h3>
                                <ul className="cap-points cap-link-list">
                                    {(popularCategories || []).slice(0, 5).map((item, index) => (
                                        <li key={item.id || index}>
                                            <span className="cap-check cap-icon-sm cap-icon-purple">📁</span>
                                            <Link to={`${AppRoutes.explore}?open=${item._slugs[0]}`} onClick={() => PostHogService.capture(PostHogEvents.POPULAR_CATEGORY_CLICKED, { title: item.title, slug: item._slugs[0] })} className="hover-blue">
                                                {item.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
